import React from 'react'
import { Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'


const ProjectDetail5 = () => {
  return (
   <Container fluid className='project-section'>
    <div className='project-photo'>
        <div>
        <img className='img-fluid' src="https://i.ibb.co/BzFMzFj/Screen-Shot-Tool-20221211221104.png" alt="Screen-Shot-Tool-20221211190706" border="0"/>
        </div>
        <div >
        <img alt="" className='img-fluid ' src="https://i.ibb.co/QKgTDmj/Screen-Shot-Tool-20221211220852.png" border="0"/>
        </div>
        <div >
        <img className='img-fluid ' src="https://i.ibb.co/sW8M5rR/Screen-Shot-Tool-20221211220916.png"  alt="" border="0"/>
        </div>
    </div>

    <div className='my-5 w-75 mx-auto text-white '>
               <h1>Project Description</h1>
               <p >This is a react website for testig your knowledge like react ,git ,html, css</p>
               <ul className='text-strat'>
                 <li>Simple website for Quiz  </li>
                 <li>Modal used to notify user about the answer </li> 
                 <li>you see your ranking</li>
          
               </ul>
               <div>
                <a className='btn btn-primary mx-1' target={"_blank"} href="https://gilded-sunshine-9879f6.netlify.app/">Live Site</a>
                <a className='btn btn-primary mx-1' target={"_blank"} href ="https://github.com/lalon147/creative-brain">Code Link</a>
              
               </div>
    </div>
              

   </Container>
  )
}

export default ProjectDetail5